var exports = {
  "k": "xe533113f--91e3bb--container",
};

module.exports = exports;
